import React, { useEffect, useState } from "react";
import {
  KioskProvider,
  KioskContextProps,
  FirebaseProvider,
  AnalyticsProvider,
} from "@popped/popshap-kiosk-components";


import { Outlet, Route, Routes, useLocation, useNavigate, useParams } from "react-router-dom";

import "./styles/app.scss";
import { DataProvider } from "./context/DataProvider";
import LandingPage from "./pages/LandingPage";
import { Header } from "./components/Header";
import EngagementPage from "./pages/Engagement";
import HotelPage from "./pages/Hotel";
import LobbyPage from "./pages/Hotel/Lobby";
import GuestPage from "./pages/Hotel/Guest";
import PoolPage from "./pages/Hotel/Pool";
import MarketPage from "./pages/Hotel/Market";
import OfficePage from "./pages/Hotel/Office";
import GiftsPage from "./pages/Hotel/Gifts";
import ValetPage from "./pages/Hotel/Valet";
import ShippingPage from "./pages/Hotel/Shipping";
import RestaurantPage from "./pages/Dining/Restaurant";
import CasualPage from "./pages/Dining/Casual";
import KitchenPage from "./pages/Dining/Kitchen";
import DiningPage from "./pages/Dining";
import BeachPage from "./pages/Beach";
import ConferencePage from "./pages/Conference";
import SpaPage from "./pages/Spa";
import TennisPage from "./pages/Tennis";
import ContinousConnectionPage from "./pages/ContinousConnection";
import GolfPage from "./pages/Golf";
import LoungePage from "./pages/Golf/Lounge";
import ShopPage from "./pages/Golf/Shop";
import CartPage from "./pages/Golf/Cart";
import HallPage from "./pages/Golf/Hall";
import BookFPage from "./pages/Solutions/Book";
import MarketingFPage from "./pages/Solutions/Marketing";
import EatecFPage from "./pages/Solutions/Eatec";
import ExpressKioskFPage from "./pages/Solutions/ExpressKiosk";
import ExpressMobileFPage from "./pages/Solutions/ExpressMobile";
import GolfFPage from "./pages/Solutions/Golf";
import GuestAppFPage from "./pages/Solutions/GuestApp";
import DigitalMenuFPage from "./pages/Solutions/DigitalMenu";
import IGFlyFPage from "./pages/Solutions/IGFly";
import IGKDSFPage from "./pages/Solutions/IGKDS";
import IGKioskFPage from "./pages/Solutions/IGKiosk";
import IGOnDemandFPage from "./pages/Solutions/IGOnDemand";
import IGQuickPayFPage from "./pages/Solutions/IGQuickPay";
import IGSmartMenuFPage from "./pages/Solutions/IGSmartMenu";
import InfoGenesisFPage from "./pages/Solutions/InfoGenesis";
import LoyaltyFPage from "./pages/Solutions/Loyalty";
import MembershipsFPage from "./pages/Solutions/Memberships";
import PMSFPage from "./pages/Solutions/PMS";
import ReserveFPage from "./pages/Solutions/Reserve";
import RetailFPage from "./pages/Solutions/Retail";
import SalesFPage from "./pages/Solutions/Sales";
import ServiceFPage from "./pages/Solutions/Service";
import SpaFPage from "./pages/Solutions/Spa";
import AboutUs from "./pages/AboutUs";
import { HeaderInitial } from "./components/HeaderInitial";
import { IdleTimeoutProvider } from "./context/idleTimoutContext";
import NoDisplay from "./components/NoDisplay";
import CasinoPage from "./pages/Casino";
import BuffetPage from "./pages/Dining/Buffet";
import FoodCourtPage from "./pages/Dining/FoodCourt";
import EmployeeDiningPage from "./pages/Dining/EmployeeDining";
import FoodTrucksPage from "./pages/Dining/FoodTrucks";
import CasinoFloorPage from "./pages/Casino/CasinoFloor";
import PokerRoomPage from "./pages/Casino/PokerRoom";
import SportsbookPage from "./pages/Casino/Sportsbook";
import GasStationPage from "./pages/GasStation";
import TheatrePage from "./pages/Theatre";
import Book4TimeFPage from "./pages/Solutions/Book4Time";


// directory profile

function App() {
  const { pathname } = useLocation();


  const firebaseConfig = {
    apiKey: "AIzaSyCVaAByzO-nOFY6XaVXLgTYHiGxlUWkZII",
    authDomain: "popshap-kiosks-dev.firebaseapp.com",
    projectId: "popshap-kiosks-dev",
    storageBucket: "popshap-kiosks-dev.appspot.com",
    messagingSenderId: "827903591200",
    appId: "1:827903591200:web:a3a3dd97574a553fb64d45",
    measurementId: "G-X3G2G8FZJ4",
  };

  const firebaseConfigProd = {
    apiKey: "AIzaSyBHhxW7040toMtuxfqJ15oDGO4xxCJpYEc",
    authDomain: "popshap-kiosks-live.firebaseapp.com",
    projectId: "popshap-kiosks-live",
    storageBucket: "popshap-kiosks-live.appspot.com",
    messagingSenderId: "167649908920",
    appId: "1:167649908920:web:ed844ee6dd3606f8257c4d",
    measurementId: "G-5G0NK754ZP",
  };

  const kioskProps: KioskContextProps = {
    projectId: "casino-responsive",
    clientId: "agilysys",
    layout: "vertical",
    logo: {
      src: "/assets/images/logo.png",
      width: 300,
      position: "center",
    },
  };

  const { slug } = useParams();
  const [kioskId, setKioskId] = useState<any>(null);
  useEffect(() => {
    if (pathname) {
      const kiosk = {
        kiosk: pathname.split('/')[1]
      }
      setKioskId({ ...kiosk })
    }

  }, [slug, pathname])
  
  return (
    <KioskProvider kiosk={kioskProps}>
      <FirebaseProvider
        config={
          process.env.REACT_APP_ENV === "production"
            ? firebaseConfigProd
            : firebaseConfig
        }
      >
        <AnalyticsProvider kioskId={kioskId}>
		    	<DataProvider>
            {/*pathname !== "/" && <Header />*/}            
            <NoDisplay />
		    		<Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/engagement" element={<EngagementPage />} />
              <Route path="/hotel" element={<Outlet />}>
                <Route index element={<HotelPage />} />
                <Route path="lobby" element={<LobbyPage />} />
                <Route path="guest" element={<GuestPage />} />
                <Route path="pool" element={<PoolPage />} />
                <Route path="gifts" element={<GiftsPage />} />
                <Route path="gran-n-go" element={<MarketPage />} />
                <Route path="valet" element={<ValetPage />} />
                <Route path="office" element={<OfficePage />} />
                <Route path="shipping" element={<ShippingPage />} />
              </Route>
              <Route path="/dining" element={<Outlet />}>
                <Route index element={<DiningPage />} />
                <Route path="restaurant" element={<RestaurantPage />} />
                <Route path="casual" element={<CasualPage />} />
                <Route path="kitchen" element={<KitchenPage />} />
                <Route path="buffet" element={<BuffetPage />} />
                <Route path="food-court" element={<FoodCourtPage />} />
                <Route path="employee-dining" element={<EmployeeDiningPage />} />
                <Route path="food-trucks" element={<FoodTrucksPage />} />
              </Route>
              <Route path="/casino" element={<Outlet />}>
                <Route index element={<CasinoPage />} />
                <Route path="casino-floor" element={<CasinoFloorPage />} />
                <Route path="poker-room" element={<PokerRoomPage />} />
                <Route path="sportsbook" element={<SportsbookPage />} />
              </Route>
              <Route path="/beach" element={<BeachPage />} />
              <Route path="/conference" element={<ConferencePage />} />
              <Route path="/spa" element={<SpaPage />} />
              <Route path="/tennis" element={<TennisPage />} />
              <Route path="/gas-station" element={<GasStationPage />} />
              <Route path="/theatre" element={<TheatrePage />} />
              <Route path="/golf" element={<Outlet />}>
                <Route index element={<GolfPage />} />
                <Route path="lounge" element={<LoungePage />} />
                <Route path="shop" element={<ShopPage />} />
                <Route path="cart" element={<CartPage />} />
                <Route path="hall" element={<HallPage />} />
              </Route>
              <Route path="/connection" element={<ContinousConnectionPage />} />
              <Route path="/solutions/book" element={<BookFPage />} />
              <Route path="/solutions/marketing" element={<MarketingFPage />} />
              <Route path="/solutions/eatec" element={<EatecFPage />} />
              <Route path="/solutions/express-kiosk" element={<ExpressKioskFPage />} />
              <Route path="/solutions/express-mobile" element={<ExpressMobileFPage />} />
              <Route path="/solutions/golf" element={<GolfFPage />} />
              <Route path="/solutions/guest-app" element={<GuestAppFPage />} />
              <Route path="/solutions/digital-menu" element={<DigitalMenuFPage />} />
              <Route path="/solutions/ig-fly" element={<IGFlyFPage />} />
              <Route path="/solutions/ig-kds" element={<IGKDSFPage />} />
              <Route path="/solutions/ig-kiosk" element={<IGKioskFPage />} />
              <Route path="/solutions/ig-on-demand" element={<IGOnDemandFPage />} />
              <Route path="/solutions/ig-quick-pay" element={<IGQuickPayFPage />} />
              <Route path="/solutions/ig-smart-menu" element={<IGSmartMenuFPage />} />
              <Route path="/solutions/info-genesis" element={<InfoGenesisFPage />} />
              <Route path="/solutions/loyalty" element={<LoyaltyFPage />} />
              <Route path="/solutions/memberships" element={<MembershipsFPage />} />
              <Route path="/solutions/pms" element={<PMSFPage />} />
              <Route path="/solutions/reserve" element={<ReserveFPage />} />
              <Route path="/solutions/retail" element={<RetailFPage />} />
              <Route path="/solutions/sales" element={<SalesFPage />} />
              <Route path="/solutions/service" element={<ServiceFPage />} />
              <Route path="/solutions/spa" element={<SpaFPage />} />
              <Route path="/solutions/book4time" element={<Book4TimeFPage />} />
              <Route path="/aboutus" element={<AboutUs/>} />
              <Route path="/aboutus/agilysys" element={<AboutUs/>} />
            </Routes>
		    	</DataProvider>
		    </AnalyticsProvider>
      </FirebaseProvider>
    </KioskProvider>
  );
}

export default App;
